module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/normalize-wheel/index.js
// module id = KCpP
// module chunks = 15